import { Instagram, Mail, MapPin, Phone, Tag } from "lucide-react";
import { COMPANY, INSTAGRAM_URL } from "../../lib/content";
import { Reveal } from "./Reveal";
import { QuoteForm } from "./QuoteForm";

const Info = ({ icon: Icon, label, value, testId }) => (
  <div className="flex items-start gap-4 py-4" data-testid={testId}>
    <span className="grid h-10 w-10 shrink-0 place-items-center rounded-md bg-white/10 text-cs-yellow">
      <Icon className="h-5 w-5" />
    </span>
    <div>
      <div className="text-xs font-semibold uppercase tracking-[0.16em] text-white/50">{label}</div>
      <div className="mt-0.5 text-[15px] font-medium text-white">{value}</div>
    </div>
  </div>
);

export const Contact = () => (
  <section id="contact" data-testid="contact-section" className="scroll-mt-20 bg-cs-navy py-20 md:py-28">
    <div className="mx-auto grid max-w-6xl grid-cols-1 gap-12 px-5 sm:px-8 lg:grid-cols-[5fr_7fr] lg:gap-16">
      <Reveal>
        <span className="eyebrow !text-cs-yellow">Parlons de votre chantier</span>
        <h2 className="section-title !text-white">Contact</h2>
        <div data-testid="launch-offer" className="mt-8 flex items-start gap-3 rounded-xl border border-cs-yellow/30 bg-cs-yellow/10 p-5">
          <Tag className="mt-0.5 h-5 w-5 shrink-0 text-cs-yellow" />
          <p className="text-[15px] text-white/90">
            Offre de lancement : <b className="text-cs-yellow">-20 % sur le premier passage</b>.
          </p>
        </div>
        <div className="mt-6 divide-y divide-white/10">
          <Info icon={Phone} label="Téléphone" value={<a href={`tel:${COMPANY.tel}`} className="nav-link" data-testid="contact-phone-link">{COMPANY.phone}</a>} testId="contact-phone" />
          <Info icon={Mail} label="Email" value={<a href="mailto:info@stopcheni.ch" className="nav-link" data-testid="contact-email-link">info@stopcheni.ch</a>} testId="contact-email" />
          <Info icon={Instagram} label="Instagram" value={<a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="nav-link" data-testid="contact-instagram-link">@stopcheni.ch</a>} testId="contact-instagram" />
          <Info icon={MapPin} label="Adresse" value={`${COMPANY.street}, ${COMPANY.npa} ${COMPANY.city}`} testId="contact-address" />
          <Info icon={MapPin} label="Zone" value="Lausanne, Ouest lausannois, Morges, Riviera" testId="contact-zone" />
        </div>
      </Reveal>
      <Reveal delay={0.12} id="devis" className="scroll-mt-28">
        <QuoteForm />
      </Reveal>
    </div>
  </section>
);
